import { takeEvery, fork, put, call } from 'redux-saga/effects';

import { api } from './api';

import { fetchAllContentRejected, fetchAllContentResolved } from './actions';

function* watchFetchProducts() {
  yield takeEvery('fetchAllContent', fetchProducts);
}

export function* fetchProducts(action: any) {
  try {
    const products = yield call(api.allEntries);

    yield put(fetchAllContentResolved(products));
  } catch (err) {
    yield put(fetchAllContentRejected(err));
  }
}

export default function* rootSaga() {
  yield fork(watchFetchProducts);
}



// WEBPACK FOOTER //
// ./src/sagas.ts